/* eslint-disable */
import React from "react";
import Dashboard from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
import BubbleChart from "@material-ui/icons/BubbleChart";
import LocationOn from "@material-ui/icons/LocationOn";
import Notifications from "@material-ui/icons/Notifications";
import EventIcon from "@material-ui/icons/Event";
import { Home, set_meal, Store } from "@material-ui/icons";
import trophy from "@material-ui/icons/EmojiEvents";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faFish } from "@fortawesome/free-solid-svg-icons";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import products from "views/PurchasedProducts/PurchasedProducts.js";
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';

import Unarchive from "@material-ui/icons/Unarchive";
import Language from "@material-ui/icons/Language";
// core components/views for Admin layout
import DashboardPage from "views/Dashboard/Dashboard.js";
import Fish from "views/Fish/Fish.js";
import Typography from "views/Typography/Typography.js";
import Icons from "views/Icons/Icons.js";
import Maps from "views/Maps/Maps.js";
import DrawWinner from "views/DrawWinner/DrawWinner.js";
import LogOut from "views/LogOut/logout";
import Event from "views/Events/Event.js";
import Prize from "views/Prize/prize.js";
import Shop from "views/Shop/shop.js";
import fishermen from "views/Fishermen/Fishermen.js";
import Sponsors from "views/Sponsors/Sponsors.js";
import Customer from "views/Customer/customers.js"
import PeopleIcon from '@material-ui/icons/People';
// import prize trophy icon
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents';
import ThumbsUpDownIcon from '@material-ui/icons/ThumbsUpDown';
import Chances from "views/CustomerPanel/Chances/chances";

// core components/views for RTL layout
import RTLPage from "views/RTLPage/RTLPage.js";

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Home",
    icon: Home,
    component: DashboardPage,
    layout: "/admin",
  },
  {
    path: "/fishermen",
    name: "Fishermen",

    icon: Person,
    component: fishermen,
    layout: "/admin",
  },
  {
    path: "/customers",
    name: "Customers",

    icon: PeopleIcon,
    component: Customer,
    layout: "/admin",
  },
  {
    path: "/chances",
    name: "Extra Chances",

    icon: EmojiEventsIcon,
    component: Chances,
    layout: "/admin",
  },
  {
    path: "/events",
    name: "Events",

    icon: EventIcon,
    component: Event,
    layout: "/admin",
  },
  {
    path: "/drawWinner",
    name: "Draw Winner",

    icon: AttachMoneyIcon,
    component: DrawWinner,
    layout: "/admin",
  },
  {
    path: "/prizes",
    name: "Prizes",

    icon: trophy,
    component: Prize,
    layout: "/admin",
  },
  {
    path: "/shop",
    name: "Shop",

    icon: Store,
    component: Shop,
    layout: "/admin",
  },
  {
    path: "/sponsors",
    name: "Sponsors",

    icon: ThumbsUpDownIcon,
    component: Sponsors,
    layout: "/admin",
  },

  {
    path: "/purchasedproducts",
    name: "Purchased Products",

    icon: ShoppingCartIcon,
    component: products,
    layout: "/admin",
  },
  {
    path: "/logout",
    name: "LogOut",

    icon: ExitToAppIcon,
    component: LogOut,
    layout: "/admin",
  },
];

export default dashboardRoutes;
